/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import './styles/index.css';

import * as THREE from 'three';

import { AudioSystem, SoundEffectComponent } from './audio';
import { FollowComponent, FollowSystem } from './follow';
import { GrabComponent, GrabSystem } from './grab';
import { PlayerComponent, PlayerSystem } from './player';
import { SpinComponent, SpinSystem } from './spin';
import {
	acceleratedRaycast,
	computeBoundsTree,
	disposeBoundsTree,
} from 'three-mesh-bvh';

import { ConfigUISystem } from './configUI';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { GlobalComponent } from './global';
import { InlineSystem } from './landing';
import { KTX2Loader } from 'three/examples/jsm/loaders/KTX2Loader';
import { PointerSystem } from './pointer';
import { SizingSystem } from './size';
import { WelcomeSystem } from './welcome';
import { World } from '@lastolivegames/becsy';
import { setupScene } from './scene';

const LOADING_MANAGER = new THREE.LoadingManager();
THREE.BufferGeometry.prototype.computeBoundsTree = computeBoundsTree;
THREE.BufferGeometry.prototype.disposeBoundsTree = disposeBoundsTree;
THREE.Mesh.prototype.raycast = acceleratedRaycast;
const DRACO_LOADER = new DRACOLoader(LOADING_MANAGER).setDecoderPath(
	`vendor/draco/gltf/`,
);
const KTX2_LOADER = new KTX2Loader(LOADING_MANAGER).setTranscoderPath(
	`vendor/basis/`,
);

const worldDef = {
	defs: [
		GlobalComponent,
		PlayerComponent,
		PlayerSystem,
		WelcomeSystem,
		ConfigUISystem,
		SizingSystem,
		SpinComponent,
		SpinSystem,
		GrabComponent,
		GrabSystem,
		FollowComponent,
		FollowSystem,
		InlineSystem,
		SoundEffectComponent,
		AudioSystem,
		PointerSystem,
	],
};

World.create(worldDef).then((world) => {
	let ecsexecuting = false;
	const { scene, camera, renderer } = setupScene();

	const gltfLoader = new GLTFLoader(LOADING_MANAGER)
		.setCrossOrigin('anonymous')
		.setDRACOLoader(DRACO_LOADER)
		.setKTX2Loader(KTX2_LOADER.detectSupport(renderer));

	world.createEntity(GlobalComponent, { renderer, camera, scene, gltfLoader });

	renderer.setAnimationLoop(function () {
		renderer.render(scene, camera);
		if (ecsexecuting == false) {
			ecsexecuting = true;
			world.execute().then(() => {
				ecsexecuting = false;
			});
		}
	});
});
